"use client";

import Link from "next/link";
import { useProStatus } from "@/hooks/use-pro-status";

export function GoProLink() {
  const isPro = useProStatus();
  return (
    <div className="min-w-[72px] sm:min-w-[100px] h-9 sm:h-10">
      {!isPro && (
        <Link
          href="/pricing"
          className="flex min-w-[72px] sm:min-w-[100px] h-9 sm:h-10 px-4 sm:px-6 bg-primary text-primary-foreground text-sm font-bold rounded-lg hover:brightness-110 transition-all items-center justify-center shadow-lg shadow-primary/20"
        >
          Go Pro
        </Link>
      )}
    </div>
  );
}
